import axios from 'axios'
import { createSelector } from 'reselect'
import { subscriptionStatus, businessNature, ownership, nameSort, benefitStatus, lineLevelSort } from '../../../../utils/espSortNFilter/types'
import { getAPIHost } from '../../../../utils/helper'
import { getAccessHeader, getADA } from '../../../../utils/loginSession'

// Action Types
export const FETCH_SUBSCRIPTIONS_REQUEST = "FETCH_SUBSCRIPTIONS_REQUEST"
export const FETCH_SUBSCRIPTIONS_SUCCESS = "FETCH_SUBSCRIPTIONS_SUCCESS"
export const FETCH_SUBSCRIPTIONS_FAILURE = "FETCH_SUBSCRIPTIONS_FAILURE"
export const FETCH_SUBSCRIPTION_DETAIL_REQUEST = "FETCH_SUBSCRIPTION_DETAIL_REQUEST"
export const FETCH_SUBSCRIPTION_DETAIL_SUCCESS = "FETCH_SUBSCRIPTION_DETAIL_SUCCESS"
export const FETCH_SUBSCRIPTION_DETAIL_FAILURE = "FETCH_SUBSCRIPTION_DETAIL_FAILURE"

// Actions

// Thunks
export const fakeSubscriptionData = [
  {
    id: 1,
    order: 1,
    name: "John Tan",
    memberNo: "736212",
    memberType: businessNature.ABO,
    subscriptions: [
      {
        id: 1001,
        planName: "eSpring Subscription Plan",
        planCode: "1001",
        duration: "Feb 2024 – Feb 2029 (18/48)",
        nextDue: "10 Jul 2025",
        status: "ACTIVE",
        benefits: [
          { icon: "🧼", period: "Aug 2024 – Jan 2026", label: "e3 Carbon Filter", status: "available" },
          { icon: "🔧", period: "18 Jun 2025", label: "On-Site Service", status: "scheduled" }
        ]
      },
      {
        id: 1002,
        planName: "eSpring Subscription Plan",
        planCode: "1002",
        duration: "Jun 2025 – Jun 2029 (1/48)",
        nextDue: "10 Aug 2025",
        status: "OVERDUE",
        benefits: [
          { icon: "🧼", period: "Nov 2025 – Apr 2027", label: "e3 Carbon Filter", status: "scheduled" },
          { icon: "🔧", period: "Nov 2025 – Apr 2027", label: "On-Site Service", status: "scheduled" }
        ]
      }
    ]
  },
  {
    id: 2,
    order: 2,
    name: "Aisha Lim",
    memberNo: "7016674394",
    memberType: businessNature.APC,
    subscriptions: [
      {
        id: 1005,
        planName: "eSpring Subscription Plan",
        planCode: "1005",
        duration: "Jan 2024 – Jan 2028 (31/48)",
        nextDue: "10 Jul 2026",
        status: "ACTIVE",
        benefits: [
          { icon: "🧼", period: "20 Jul 2026", label: "e3 Carbon Filter", status: "available" },
          { icon: "🔧", period: "20 Jul 2026", label: "On-Site Service", status: "available" },
          { icon: "🧼", period: "Jan 2024 – Jun 2024", label: "e3 Carbon Filter", status: "completed" }
        ]
      }
    ]
  },
  {
    id: 3,
    order: 3,
    name: "Sarah Chen",
    memberNo: "1009975",
    memberType: businessNature.ABO,
    subscriptions: [
      {
        id: 1006,
        planName: "eSpring Subscription Plan",
        planCode: "1006",
        duration: "Mar 2024 – Mar 2028 (12/48)",
        nextDue: "10 Mar 2025",
        status: "ACTIVE",
        benefits: [
          { icon: "🧼", period: "Sep 2024 – Feb 2026", label: "e3 Carbon Filter", status: "available" },
          { icon: "🔧", period: "15 Sep 2025", label: "On-Site Service", status: "scheduled" },
          { icon: "🔧", period: "10 Mar 2024", label: "On-Site Service", status: "completed" }
        ]
      },
      {
        id: 1007,
        planName: "eSpring Subscription Plan",
        planCode: "1007",
        duration: "Aug 2024 – Aug 2028 (4/48)",
        nextDue: "10 Dec 2024",
        status: "OVERDUE",
        benefits: [
          { icon: "🧼", period: "Feb 2025 – Jul 2026", label: "e3 Carbon Filter", status: "scheduled" },
          { icon: "🔧", period: "20 Feb 2026", label: "On-Site Service", status: "scheduled" },
          { icon: "🧼", period: "Aug 2024 – Jan 2025", label: "e3 Carbon Filter", status: "expired" }
        ]
      },
      {
        id: 1008,
        planName: "eSpring Subscription Plan",
        planCode: "1008",
        duration: "Nov 2023 – Nov 2027 (25/48)",
        nextDue: "10 Dec 2024",
        status: "ACTIVE",
        benefits: [
          { icon: "🧼", period: "May 2024 – Oct 2025", label: "e3 Carbon Filter", status: "available" },
          { icon: "🔧", period: "12 May 2025", label: "On-Site Service", status: "scheduled" },
          { icon: "🔧", period: "15 Nov 2023", label: "On-Site Service", status: "completed" }
        ]
      }
    ]
  },
  {
    id: 4,
    order: 4,
    name: "Michael Wong",
    memberNo: "2002269",
    memberType: businessNature.APC,
    subscriptions: [
      {
        id: 1009,
        planName: "eSpring Subscription Plan",
        planCode: "1009",
        duration: "Apr 2024 – Apr 2028 (8/48)",
        nextDue: "10 Dec 2024",
        status: "ACTIVE",
        benefits: [
          { icon: "🧼", period: "Oct 2024 – Mar 2026", label: "e3 Carbon Filter", status: "available" },
          { icon: "🔧", period: "20 Oct 2025", label: "On-Site Service", status: "scheduled" },
          { icon: "🧼", period: "Apr 2024 – Sep 2024", label: "e3 Carbon Filter", status: "completed" }
        ]
      },
      {
        id: 1010,
        planName: "eSpring Subscription Plan",
        planCode: "1010",
        duration: "Jul 2024 – Jul 2028 (5/48)",
        nextDue: "10 Jan 2025",
        status: "ACTIVE",
        benefits: [
          { icon: "🧼", period: "Jan 2025 – Jun 2026", label: "e3 Carbon Filter", status: "available" },
          { icon: "🔧", period: "15 Jan 2026", label: "On-Site Service", status: "scheduled" },
          { icon: "🧼", period: "Jul 2024 – Dec 2024", label: "e3 Carbon Filter", status: "expired" }
        ]
      }
    ]
  },
  {
    id: 5,
    order: 5,
    name: "Emma Lee",
    memberNo: "1009451",
    memberType: businessNature.ABO,
    subscriptions: [
      {
        id: 1011,
        planName: "eSpring Subscription Plan",
        planCode: "1011",
        duration: "May 2024 – May 2028 (7/48)",
        nextDue: "10 Dec 2024",
        status: "ACTIVE",
        benefits: [
          { icon: "🧼", period: "Nov 2024 – Apr 2026", label: "e3 Carbon Filter", status: "available" },
          { icon: "🔧", period: "25 Nov 2025", label: "On-Site Service", status: "scheduled" },
          { icon: "🔧", period: "15 May 2024", label: "On-Site Service", status: "completed" },
          { icon: "🧼", period: "May 2024 – Oct 2024", label: "e3 Carbon Filter", status: "expired" }
        ]
      }
    ]
  },
  {
    id: 6,
    order: 6,
    name: "David Kumar",
    memberNo: "3008171",
    memberType: businessNature.APC,
    subscriptions: [
      {
        id: 1012,
        planName: "eSpring Subscription Plan",
        planCode: "1012",
        duration: "Dec 2023 – Dec 2027 (24/48)",
        nextDue: "10 Dec 2024",
        status: "ACTIVE",
        benefits: [
          { icon: "🧼", period: "Jun 2024 – Nov 2025", label: "e3 Carbon Filter", status: "available" },
          { icon: "🔧", period: "10 Jun 2025", label: "On-Site Service", status: "scheduled" },
          { icon: "🧼", period: "Dec 2023 – May 2024", label: "e3 Carbon Filter", status: "completed" }
        ]
      },
      {
        id: 1013,
        planName: "eSpring Subscription Plan",
        planCode: "1013",
        duration: "Sep 2024 – Sep 2028 (3/48)",
        nextDue: "10 Dec 2024",
        status: "OVERDUE",
        benefits: [
          { icon: "🧼", period: "Mar 2025 – Aug 2026", label: "e3 Carbon Filter", status: "scheduled" },
          { icon: "🔧", period: "28 Mar 2026", label: "On-Site Service", status: "scheduled" },
          { icon: "🧼", period: "Sep 2024 – Feb 2025", label: "e3 Carbon Filter", status: "expired" }
        ]
      },
      {
        id: 1014,
        planName: "eSpring Subscription Plan",
        planCode: "1014",
        duration: "Jun 2023 – Jun 2027 (30/48)",
        nextDue: "10 Dec 2024",
        status: "ACTIVE",
        benefits: [
          { icon: "🧼", period: "Dec 2023 – May 2025", label: "e3 Carbon Filter", status: "available" },
          { icon: "🔧", period: "05 Dec 2024", label: "On-Site Service", status: "available" },
          { icon: "🔧", period: "20 Jun 2023", label: "On-Site Service", status: "completed" },
          { icon: "🧼", period: "Jun 2023 – Nov 2023", label: "e3 Carbon Filter", status: "completed" }
        ]
      },
      {
        id: 1015,
        planName: "eSpring Subscription Plan",
        planCode: "1015",
        duration: "Feb 2024 – Feb 2028 (10/48)",
        nextDue: "10 Feb 2025",
        status: "ACTIVE",
        benefits: [
          { icon: "🧼", period: "Aug 2024 – Jan 2026", label: "e3 Carbon Filter", status: "available" },
          { icon: "🔧", period: "18 Aug 2025", label: "On-Site Service", status: "scheduled" },
          { icon: "🧼", period: "Feb 2024 – Jul 2024", label: "e3 Carbon Filter", status: "completed" }
        ]
      }
    ]
  },
  {
    id: 7,
    order: 7,
    name: "Rachel Ng",
    memberNo: "3000237",
    memberType: businessNature.ABO,
    subscriptions: [
      {
        id: 1016,
        planName: "eSpring Subscription Plan",
        planCode: "1016",
        duration: "Oct 2023 – Oct 2027 (26/48)",
        nextDue: "10 Dec 2024",
        status: "OVERDUE",
        benefits: [
          { icon: "🧼", period: "Apr 2024 – Sep 2025", label: "e3 Carbon Filter", status: "available" },
          { icon: "🔧", period: "05 Apr 2025", label: "On-Site Service", status: "scheduled" },
          { icon: "🔧", period: "12 Oct 2023", label: "On-Site Service", status: "completed" },
          { icon: "🧼", period: "Oct 2023 – Mar 2024", label: "e3 Carbon Filter", status: "completed" }
        ]
      },
      {
        id: 1017,
        planName: "eSpring Subscription Plan",
        planCode: "1017",
        duration: "Jan 2024 – Jan 2028 (11/48)",
        nextDue: "10 Jan 2025",
        status: "ACTIVE",
        benefits: [
          { icon: "🧼", period: "Jul 2024 – Dec 2025", label: "e3 Carbon Filter", status: "available" },
          { icon: "🔧", period: "22 Jul 2025", label: "On-Site Service", status: "scheduled" },
          { icon: "🧼", period: "Jan 2024 – Jun 2024", label: "e3 Carbon Filter", status: "expired" },
          { icon: "🔧", period: "25 Jan 2024", label: "On-Site Service", status: "completed" }
        ]
      }
    ]
  }
];

export const fetchSubscriptions = () => async(dispatch, getState) => {
  dispatch({type: FETCH_SUBSCRIPTIONS_REQUEST})
  const host = getAPIHost()
  let searchQuery = new URLSearchParams({
    aff: "100",
    aboid: getADA()
  }).toString()
  let url = `${host}/esp/getSubscriptionList?${searchQuery}`

  try {
    const res = await axios.get(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: getAccessHeader(getState()).Authorization
      }
    })

    if (res.status !== 200) {
      dispatch({type: FETCH_SUBSCRIPTIONS_FAILURE, error: "Non 200 response"})
      console.log(res.data)
    } else {
      dispatch({type: FETCH_SUBSCRIPTIONS_SUCCESS, payload: res.data})
    }
    //setTimeout(() => {
    //  console.log("Fake fetch subscriptions timeout 4secs")
    //  //dispatch({type: FETCH_SUBSCRIPTIONS_SUCCESS, payload: fakeSubscriptionData})
    //  dispatch({type: FETCH_SUBSCRIPTIONS_SUCCESS, payload: []})
    //}, 2000)
  } catch(err){
    dispatch({type: FETCH_SUBSCRIPTIONS_FAILURE, error: err})
  }
}

export const fetchSubscriptionDetail = ({ aboNo, subscriptionId }) => async(dispatch, getState) => {
  dispatch({type: FETCH_SUBSCRIPTION_DETAIL_REQUEST})
  const host = getAPIHost()
  let searchQuery = new URLSearchParams({
    aff: "100",
    aboid: aboNo,
    subscriptionId,
    selfAboId: getADA()
  }).toString()
  let url = `${host}/esp/getSubscriptionDetail?${searchQuery}`
  try {
    const res = await axios.get(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: getAccessHeader(getState()).Authorization
      }
    })

    if (res.status !== 200) {
      dispatch({type: FETCH_SUBSCRIPTION_DETAIL_FAILURE, error: "Non 200 response"})
      console.log(res.data)
    } else {
      dispatch({type: FETCH_SUBSCRIPTION_DETAIL_SUCCESS, payload: res.data})
    }
  } catch(err) {
    console.error(err)
    dispatch({type: FETCH_SUBSCRIPTION_DETAIL_FAILURE, error: err})
  }
}

// Selectors
const selectSortNFilter = (state) => state.sortNFilterState && state.sortNFilterState.applied
export const selectSubscriptions = (state) => state.subscriptionsState
//const selectIsApplying = (state) => state.sortNFilterState && state.sortNFilterState.isApplying
//const selectMyAboNo = (state) => state.myPerfStatsState && state.myPerfStatsState.myPerformanceStats && state.myPerfStatsState.myPerformanceStats[0] && state.myPerfStatsState.myPerformanceStats[0].currentHighestGarAwards && state.myPerfStatsState.myPerformanceStats[0].currentHighestGarAwards.abo
export const selectDraftFullTextSearch = (state) => state.sortNFilterState && state.sortNFilterState.draft && state.sortNFilterState.draft.fullTextSearch

export const selectOverdueSubscriptionCount = (state) => {
  let count = 0
  const subscriptions = selectSubscriptions(state)
  if (subscriptions.list) {
    const list = subscriptions.list.subscriptionsList
    list.forEach(i => {
      const filteredUserSubscriptions = i.subscriptions.filter(i => [subscriptionStatus.OVERDUE].includes(i.subscriptionStatus))
      count += filteredUserSubscriptions.length
    })
  }

  return count
}

export const selectScheduledSubscriptionCount = (state) => {
  let count = 0
  const subscriptions = selectSubscriptions(state)
  if (subscriptions.list) {
    const list = subscriptions.list.subscriptionsList
    list.forEach(i => {
      i.subscriptions.forEach(i => {
        const filteredUserSubscriptionBenefits = i.serviceBenefits.filter(i => [benefitStatus.SCHEDULED].includes(i.status))
        count += filteredUserSubscriptionBenefits.length
      })
    })
  }

  return count
}

export const selectActiveSubscriptionCount = (state) => {
  let count = 0
  const subscriptions = selectSubscriptions(state)
  if (subscriptions.list) {
    const list = subscriptions.list.subscriptionsList
    list.forEach(i => {
      const filteredUserSubscriptions = i.subscriptions.filter(i => [subscriptionStatus.ACTIVE].includes(i.subscriptionStatus))
      count += filteredUserSubscriptions.length
    })
  }

  return count
}

export const selectSelfPV = (state) => {
  const subscriptions = selectSubscriptions(state)?.list?.subscriptionsList
  return subscriptions?.find(i => i.aboId == getADA())?.totalPv || 0 
}

export const selectGPV = (state) => {
  const subscriptions = selectSubscriptions(state)?.list?.subscriptionsList
  return subscriptions?.reduce((acc, i) => (acc + i.totalPv), 0) || 0
}

export const selectSelfNextPV = (state) => {
  const subscriptions = selectSubscriptions(state)?.list?.subscriptionsList
  return subscriptions?.find(i => i.aboId == getADA())?.nextSubtotalPv || 0
}

export const selectNextGPV = (state) => {
  const subscriptions = selectSubscriptions(state)?.list?.subscriptionsList
  return subscriptions?.reduce((acc, i) => (acc + i.nextSubtotalPv), 0) || 0
}

export const selectSortNFilteredSubscriptions = createSelector(
  [selectSortNFilter, selectSubscriptions],
  (sortNFilter, subscriptions) => {
    if (!subscriptions || !subscriptions.list) return {...subscriptions}

    // If there's no applied sort/filter, return subscriptions unchanged
    if (!sortNFilter) return {...subscriptions}

    let tempList = {...subscriptions}.list.subscriptionsList

    // apply filter
    if (sortNFilter.filter) {
      // subscriptionStatus
      if (sortNFilter.filter.subscriptionStatus) {
        tempList = tempList.reduce((acc, i) => {
          //subscriptions structure = user -> subscriptions
          const filteredUserSubscriptions = i.subscriptions.filter(i => sortNFilter.filter.subscriptionStatus.includes(i.subscriptionStatus))

          if (filteredUserSubscriptions.length > 0) {
            acc.push({
              ...i,
              subscriptions: [...filteredUserSubscriptions]
            })
          }
          
          return acc
        }, [])
      }

      // benefits status filter
      if (sortNFilter.filter.benefitStatus) {
        tempList = tempList.reduce((acc, i) => {
          const internalSubs = i.subscriptions.reduce((sacc, s) => {
            // use status which already modified to readable and front end supported status
            const serviceBenefits = s.serviceBenefits.filter(sb => sortNFilter.filter.benefitStatus.includes(sb.status))

            if (serviceBenefits.length) {
              // just subscriptions without user
              sacc.push({
                ...s
              })
            }
            
            return sacc
          }, [])

          if (internalSubs.length) {
              acc.push({
              ...i,
              subscriptions: [...i.subscriptions]
            })
          }

          return acc
        }, [])
      }

      // member type
      if (sortNFilter.filter.businessNature) {
        tempList = tempList.filter(i => sortNFilter.filter.businessNature.includes(i.businessNature))
      }

      // ownership filter
      if (sortNFilter.filter.ownership) {
        if (!sortNFilter.filter.ownership.includes(ownership.SELF)) {
          tempList = tempList.filter(i => i.aboId != getADA())
        }

        if (!sortNFilter.filter.ownership.includes(ownership.OTHER)) {
          tempList = tempList.filter(i => i.aboId == getADA())
        }
      }
    }
    // apply sort
    switch(sortNFilter.sortBy) {
      case nameSort.A_TO_Z:
        tempList.sort((a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();

          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        })
        break
      case nameSort.Z_TO_A:
        tempList.sort((a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();

          if (nameB < nameA) return -1;
          if (nameB > nameA) return 1;
          return 0;
        })
        break
      case lineLevelSort.HIGH_TO_LOW:
        tempList.sort((a, b) => {
          const lineLevelA = a.lineLevel
          const lineLevelB = b.lineLevel

          return lineLevelA > lineLevelB ? 1 : -1
        })
        break
      case lineLevelSort.LOW_TO_HIGH:
        tempList.sort((a, b) => {
          const lineLevelA = a.lineLevel
          const lineLevelB = b.lineLevel

          return lineLevelB > lineLevelA ? 1 : -1
        })
        break
      default: //set owner as first
        {
          const itemIndex = tempList.findIndex(i => i.aboId == getADA())
          const item = tempList.splice(itemIndex,1)[0]
          if (item) tempList.unshift(item)
          break
        }
    }

    // search
    //let query = sortNFilter.fullTextSearch
    //if (query == "" || query == null || query == undefined ) return {...subscriptions, list: { ...subscriptions.list, subscriptionsList: tempList }}

    //if (tempList?.length > 0) {
    //  let searchSuggestionsList = [];
    //  if (!isNaN(query)) {
    //    tempList?.map(item => {
    //      if (item?.aboId.toString().includes(query))
    //        searchSuggestionsList.push(item);
    //    })
    //  } else {
    //    query = query?.replace(/[0-9]/g, '')?.trim();
    //    tempList?.map(item => {
    //      if (item?.name.toString().toLowerCase().includes(query.toLowerCase()))
    //        searchSuggestionsList.push(item);
    //    })
    //  }

    //  return {...subscriptions, list: { ...subscriptions.list, subscriptionsList: searchSuggestionsList } }
    //}

    return {...subscriptions, list: { ...subscriptions.list, subscriptionsList: tempList }}
  }
)

export const selectSearchSuggestion = createSelector(
  [selectDraftFullTextSearch, selectSubscriptions, selectSortNFilter],
  (query, subscriptions, sortNFilter) => {
    if (!subscriptions || !subscriptions.list) return {...subscriptions}

    let tempList = {...subscriptions}.list.subscriptionsList

    // apply filter
    if (sortNFilter.filter) {
      // subscriptionStatus
      if (sortNFilter.filter.subscriptionStatus) {
        tempList = tempList.reduce((acc, i) => {
          //subscriptions structure = user -> subscriptions
          const filteredUserSubscriptions = i.subscriptions.filter(i => sortNFilter.filter.subscriptionStatus.includes(i.subscriptionStatus))

          if (filteredUserSubscriptions.length > 0) {
            acc.push({
              ...i,
              subscriptions: [...filteredUserSubscriptions]
            })
          }
          
          return acc
        }, [])
      }

      // member type
      if (sortNFilter.filter.businessNature) {
        tempList = tempList.filter(i => sortNFilter.filter.businessNature.includes(i.businessNature))
      }

      // ownership filter
      if (sortNFilter.filter.ownership) {
        if (!sortNFilter.filter.ownership.includes(ownership.SELF)) {
          tempList = tempList.filter(i => i.aboId != getADA())
        }

        if (!sortNFilter.filter.ownership.includes(ownership.OTHER)) {
          tempList = tempList.filter(i => i.aboId == getADA())
        }
      }
    }
    // apply sort
    switch(sortNFilter.sortBy) {
      case nameSort.A_TO_Z:
        tempList.sort((a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();

          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        })
        break
      case nameSort.Z_TO_A:
        tempList.sort((a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();

          if (nameB < nameA) return -1;
          if (nameB > nameA) return 1;
          return 0;
        })
        break
    }

    if (query == "" || query == null || query == undefined ) return {...subscriptions, list: tempList}

    if (tempList?.length > 0) {
      let searchSuggestionsList = [];
      if (!isNaN(query)) {
        tempList?.map(item => {
          if (item?.aboId.toString().includes(query))
            searchSuggestionsList.push(item);
        })
      } else {
        query = query?.replace(/[0-9]/g, '')?.trim();
        tempList?.map(item => {
          if (item?.name.toString().toLowerCase().includes(query.toLowerCase()))
            searchSuggestionsList.push(item);
        })
      }

      return {...subscriptions, list: searchSuggestionsList }
    }
    return {...subscriptions}
})

// Reducers
const initialState = {
  error: null,
  loading: false,
  list: null,
  selected: null
}

const subscriptionsState = (state=initialState, action) => {
  switch(action.type) {
    case FETCH_SUBSCRIPTIONS_REQUEST:
      return {
        ...state,
        loading: true
      }
    case FETCH_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload
      }
    case FETCH_SUBSCRIPTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case FETCH_SUBSCRIPTION_DETAIL_REQUEST:
      return {
        ...state,
        loading: true
      }
    case FETCH_SUBSCRIPTION_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        selected: action.payload
      }
    case FETCH_SUBSCRIPTION_DETAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    default:
      return state
  }
}

export default {
  subscriptionsState
}
